interface Dictionary {
  [name: string]: number;
}

const spreadNameToUpsellProductTypeId = (spreadName: string) => (({
  // DTG / DTF print areas
  front: 133,
  back: 134,
  'neck-inner': 502,
  'neck-outer': 503,
  'sleeve-left': 504,
  'sleeve-right': 505,
  // Embroidery print areas (OP-39731)
  'chest-left-embroidery': 592,
  'chest-right-embroidery': 593,
  'chest-center-embroidery': 594,
  'chest-large-embroidery': 595,
  'sleeve-left-embroidery': 596,
  'sleeve-right-embroidery': 597,
  'wrist-left-embroidery': 598,
  'wrist-right-embroidery': 599,
  'front-embroidery': 600,
  'back-embroidery': 601,
  'left-embroidery': 602,
  'right-embroidery': 603,
  'outer-left-leg-embroidery': 604,
  'outer-right-leg-embroidery': 605,
  'back-large-embroidery': 606,
  'center-bottom-large-embroidery': 607,
  'bottom-center-embroidery': 608,
  'right-corner-embroidery': 609,
  'right-bottom-corner-embroidery': 610,
  'right-bottom-corner-large-embroidery': 611,
  'front-left-embroidery': 612,
  'front-right-embroidery': 613,
} as Dictionary)[spreadName]);

export default spreadNameToUpsellProductTypeId;
